export default __webpack_public_path__ + "static/media/nft_right_pop.73b7e7a3.svg";